<!--
 * @Description:
 * @Author: zwcong
 * @Date: 2025-04-08 15:47:27
 * @LastEditors: zwcong
 * @LastEditTime: 2025-04-08 15:50:51
-->
<template>
  <div :id="localeClass">
    <template v-if="$nuxt.isOffline">
      <Header :show-sign-in="false" />
      <div class="network-offline-container">
        <Exception tip-text="Loading failed, please check your connection." placeholder-class-name="system-error-img" :show-retry-btn="true" @retry="reload" />
      </div>
      <Footer />
    </template>
    <template v-else-if="$nuxt.isOnline">
      <nuxt />
    </template>
  </div>
</template>

<script>
import headMixin from 'mixins/layout/head';
import Header from '@/components/global/FeatureComponents/Header/touch.vue';
import Footer from '@/components/global/FeatureComponents/Footer/touch.vue'
import Exception from 'components/common/Exception/index.vue';

export default {
  components: {
    Header,
    Exception,
    Footer,
  },
  mixins: [headMixin],
  data() {
    return {
      completeStuInfoTriggerArgs: null,
    }
  },
  computed: {
    /**
     * 当前语言环境样式名
     * 可通过此样式名叠加样式实现不同语言样式
     */
    localeClass() {
      return `locale__${this.$store.state.locale}`;
    },
  },
  watch: {
    '$nuxt.isOffline': function watchIsOffline() {
      this.$Dialog.close();
    },
  },
  mounted() {
    // 页面刷新强制跳转到页面顶部
    document.documentElement.scrollTop = 0;
  },
  methods: {
    reload() {
      if (this.$nuxt.isOffline) return;
      window.location.reload();
    },
  },
  head() {
    return {
      ...headMixin.head.call(this),
      htmlAttrs: {
        id: `style__${this.$store.state.betterme}`,
      },
      link: [{
        hid: 'icon',
        rel: 'icon',
        type: 'image/x-icon',
        href: this.$store.state.betterme === 'bettermeedu' ? 'https://download-pa-s3.thethinkacademy.com/static-pa/project/game/assets/favicon.ico' : '/favicon.ico',
      }],
    }
  },
}
</script>

<style lang="scss">
.network-offline-container {
  padding: px2vw(110) 0;
}
</style>
